import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { LinearProgress, AutoComplete, Dialog, FlatButton } from 'material-ui';
import { connect } from 'react-redux';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import fetcher from '../helpers/fetcher';
import { URL_PROJECTS } from '../constants.js';
import ProjectSelector from './ProjectSelector';

class ProjectSourceWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      loading: false,
      open: false
    };
  }

  _stopLoading = () => {
    this.setState({ loading: false });
  };

  _startLoading = () => {
    this.setState({ loading: true });
  };

  _handleOpen = () => {
    this.setState({ open: true });
  };

  _handleClose = () => {
    this.setState({ open: false });
  };

  _handleConfirm = () => {
    this._handleClose();

    this._startLoading();
    fetcher
      .get(`${URL_PROJECTS}/${this.state.selected.value}`)
      .then(res => {
        this._stopLoading();
        if (this.props.onChange) {
          this.props.onChange({
            callScreenFormData: get(res, 'data.data.meta.callScreenFormData')
          });
        }
        this.props.showNotification(
          'Field settings were successfully imported'
        );
      })
      .catch(err => {
        this.props.showNotification(
          'Error while importing field settings',
          'warning'
        );
        this._stopLoading();
      });
  };

  _onSelectItem = (data, index) => {
    if (index > -1) {
      this.setState({
        selected: data,
        open: true
      });
    }
  };

  render() {
    const actions = [
      <FlatButton label="Cancel" primary={true} onClick={this._handleClose} />,
      <FlatButton
        label="Confirm"
        primary={true}
        onClick={this._handleConfirm}
      />
    ];

    const dataSource = [];
    const enums = get(this.props, 'schema.enumNames', []);
    enums.forEach((name, index) => {
      dataSource.push({
        text: name,
        value: get(this.props, `schema.enum[${index}]`, -1)
      });
    });

    return (
      <div style={{}}>
        <Dialog
          title="Confirm fields import"
          actions={actions}
          modal={true}
          open={this.state.open}
        >
          Do you want to import the field settings from '
          {(this.state.selected || {}).text}' project?
        </Dialog>

        {this.state.loading && <LinearProgress />}
        <div className="autocomplete-inside-bootstrap">
          <ProjectSelector onSelect={this._onSelectItem} />
        </div>
      </div>
    );
  }
}

ProjectSourceWidget.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  showNotification: PropTypes.func
};

export default connect(null, {
  showNotification: showNotificationAction
})(ProjectSourceWidget);



// WEBPACK FOOTER //
// ./src/components/ProjectSourceWidget.js